import React from 'react';

import { Card } from '@betterment/style-closet-react';

import { TextShimmerLoader } from '../../Shared/components/ShimmerLoaders';

const CardShimmerLoader: React.FC = () => {
  return (
    <Card>
      <Card.Slot name="body">
        <TextShimmerLoader numLines={2} />
      </Card.Slot>
    </Card>
  );
};

export default CardShimmerLoader;
